import { GuardedComponent } from '../components/guarded-component';
import { ProjectRequestReportPage } from '../features/project-request/project-request.page';
import { UserPermissionName } from '../models/user-permission-name';

export const ProjectRequestRoute = {
  path: '/project-request',
  name: 'Project Request',
  children: [
    {
      index: true,
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_REQUESTS]} showPermissionError>
          <ProjectRequestReportPage />
        </GuardedComponent>
      ),
    },
  ],
};
